// extracted by mini-css-extract-plugin
export default {"root":"bYduKEv3bGTuNh6qeJwG","placeHolderShimmer":"TPBgKpArO1HGhRXXLyJn"};